require('./RAHireManagementPlanEmailConfigStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

//@commons
const { FormattedText } = require('core/i18n').i18n;

// @components
const RAEmailForm = require('../../../components/commons/RAEmailForm/RAEmailForm');

// @constants
const { FOURTH_STEP } = require('constants/index');

//@helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

class RAHireManagementPlanEmailConfigStep extends React.Component {
    constructor(props) {
        super(props);
        this.getValidation = this.getValidation.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleBlur(evt) {
        const { configureUserEmail } = this.props;
        const { name, value } = evt.target;
        const trimmedValue = value.trim();

        configureUserEmail({
            [name]: trimmedValue,
            [`${name}Blur`]: true,
        });
    }

    getValidation(name, value, blur, isValid) {
        const isEmpty = !value;
        const isTheSameEmailAsOriginal =
            name === 'email' &&
            PersonalDataHelper.getEmail(this.props.immProfile).toLowerCase() ===
                value.toLowerCase();
        return {
            [`${name}ErrorState`]:
                blur && (isEmpty || !isValid || isTheSameEmailAsOriginal),
            [`${name}ErrorMsg`]: isEmpty
                ? 'incomplete'
                : isTheSameEmailAsOriginal
                ? 'same'
                : 'incorrect',
        };
    }

    buildEmailSection() {
        const { configureUserEmail, immProfile, immSteps } = this.props;
        const immStep = immSteps.get(FOURTH_STEP);

        return (
            <RAEmailForm
                actionChangeValue={configureUserEmail}
                getValidation={this.getValidation}
                immStep={immStep}
                immProfileFields={immProfile}
                handleBlur={this.handleBlur} // eslint-disable-line
            />
        );
    }

    buildReadOnlyEmailSection() {
        const { immSteps } = this.props;
        const clientEmail = immSteps.getIn([FOURTH_STEP, 'email']);

        return (
            <div>
                <div className="print-label">
                    <FormattedText
                        value="raHireManagementPlan-readOnlyEmailTitle"
                        className="ra-hire-management-plan-email-config-step__info-email-title"
                    />
                </div>
                <div>
                    <span className="ra-hire-management-plan-email-config-step__info-email">
                        {clientEmail}
                    </span>
                </div>
            </div>
        );
    }

    render() {
        const { active } = this.props;
        const emailSection = active
            ? this.buildEmailSection()
            : this.buildReadOnlyEmailSection();
        return (
            <div className="ra-hire-management-plan-email-config-step">
                <div className="row">
                    <div className="col-md-12">{emailSection}</div>
                </div>
            </div>
        );
    }
}

RAHireManagementPlanEmailConfigStep.propTypes = {
    active: PropTypes.bool.isRequired,
    immSteps: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    configureUserEmail: PropTypes.func.isRequired,
};

module.exports = RAHireManagementPlanEmailConfigStep;
